import { render, staticRenderFns } from "./TransformAlignment.vue?vue&type=template&id=2f797c86&scoped=true&"
import script from "./TransformAlignment.vue?vue&type=script&lang=js&"
export * from "./TransformAlignment.vue?vue&type=script&lang=js&"
import style0 from "./TransformAlignment.vue?vue&type=style&index=0&id=2f797c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f797c86",
  null
  
)

export default component.exports